import React, { useEffect, useRef, useLayoutEffect } from "react"
import SectionHeader from "../../molecules/SectionHeader"
import Accordion from "../../molecules/Accordion"

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

import "./styles.scss"

const Services = ({ items, title, subtitle, isDesktop }) => {
  const sectionRef = useRef(null)
  gsap.registerPlugin(ScrollTrigger)

  useEffect(() => {
    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: "top-=100 top",
      end: "center top",
      onToggle: self => {
        document.body.classList.toggle("theme--dark", self.isActive)
      },
    })
  }, [sectionRef])

  useLayoutEffect(() => {
    ScrollTrigger.refresh(true)
  }, [])

  return (
    <section className="section section--services" ref={sectionRef}>
      <div className="wrapper--text">
        <SectionHeader
          attributes={{
            "data-sal": "slide-up",
            "data-sal-duration": "1000",
            "data-sal-easing": "ease",
          }}
          className="services__title"
          type="h2"
          subtitle={subtitle}
          animate
        >
          Partners in every phase <br /> of the product lifecycle
        </SectionHeader>

        <Accordion
          openFirstMobile
          isDesktop={isDesktop}
          isNumeric
          tabs={items}
          className="accordion--services"
        />
      </div>
    </section>
  )
}
export default Services
